import { components, a11yDocs, urls } from "../../data";

<let/navExpanded=false>

<script>
  document.body.style.overflowY = navExpanded ? "hidden" : "auto";
</script>

<svg style="display: none;">
  <symbol viewBox="0 0 24 24" id="site-logo">
    <polyline points="16 18 22 12 16 6"/>
    <polyline points="8 6 2 12 8 18"/>
  </symbol>

  <symbol viewBox="0 0 20 20" id="icon-menu-20">
    <path
      fill-rule="evenodd"
      d="M2 4a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Z"
      clip-rule="evenodd"
    />
  </symbol>

  <symbol viewBox="0 0 20 20" id="icon-close-20">
    <path
      fill-rule="evenodd"
      d="M3.293 3.293a1 1 0 0 1 1.414 0L10 8.586l5.293-5.293a1 1 0 1 1 1.414 1.414L11.414 10l5.293 5.293a1 1 0 0 1-1.414 1.414L10 11.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L8.586 10 3.293 4.707a1 1 0 0 1 0-1.414Z"
      clip-rule="evenodd"
    />
  </symbol>

  <symbol viewBox="0 0 24 24" id="icon-site-rocket-24" fill="currentColor">
    <path
      fill-rule="evenodd"
      d="M1.44 8.855v-.001l3.527-3.516c.34-.344.802-.541 1.285-.548h6.649l.947-.947c3.07-3.07 6.207-3.072 7.62-2.868a1.821 1.821 0 0 1 1.557 1.557c.204 1.413.203 4.55-2.868 7.62l-.946.946v6.649a1.845 1.845 0 0 1-.549 1.286l-3.516 3.528a1.844 1.844 0 0 1-3.11-.944l-.858-4.275-4.52-4.52-2.31-.463-1.964-.394A1.847 1.847 0 0 1 .98 10.693a1.843 1.843 0 0 1 .46-1.838Zm5.379 2.017-3.873-.776L6.32 6.733h4.638l-4.14 4.14Zm8.403-5.655c2.459-2.46 4.856-2.463 5.89-2.33.134 1.035.13 3.432-2.329 5.891l-6.71 6.71-3.561-3.56 6.71-6.711Zm-1.318 15.837-.776-3.873 4.14-4.14v4.639l-3.364 3.374Z"
      clip-rule="evenodd"
    />
    <path d="M9.318 18.345a.972.972 0 0 0-1.86-.561c-.482 1.435-1.687 2.204-2.934 2.619a8.22 8.22 0 0 1-1.23.302c.062-.365.157-.79.303-1.229.415-1.247 1.184-2.452 2.62-2.935a.971.971 0 1 0-.62-1.842c-.12.04-.236.084-.35.13-2.02.828-3.012 2.588-3.493 4.033a10.383 10.383 0 0 0-.51 2.845l-.001.016v.063c0 .536.434.972.97.972H2.24a7.21 7.21 0 0 0 .878-.065c.527-.063 1.248-.19 2.02-.447 1.445-.48 3.205-1.472 4.033-3.494a5.828 5.828 0 0 0 .147-.407Z"/>
  </symbol>

  <symbol viewBox="0 0 24 24" id="icon-site-puzzle-24" fill="currentColor">
    <path d="M17 22H5a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h1a4 4 0 0 1 7.3-2.18c.448.64.692 1.4.7 2.18h3a1 1 0 0 1 1 1v3a4 4 0 0 1 2.18 7.3A3.86 3.86 0 0 1 18 18v3a1 1 0 0 1-1 1ZM5 8a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11v-3.18a1 1 0 0 1 1.33-.95 1.77 1.77 0 0 0 1.74-.23 2 2 0 0 0 .93-1.37 2 2 0 0 0-.48-1.59 1.89 1.89 0 0 0-2.17-.55 1 1 0 0 1-1.33-.95V8h-3.2a1 1 0 0 1-1-1.33 1.77 1.77 0 0 0-.23-1.74 1.939 1.939 0 0 0-3-.43A2 2 0 0 0 8 6c.002.23.046.456.13.67A1 1 0 0 1 7.18 8H5Z"/>
  </symbol>

  <symbol viewBox="0 0 24 24" id="icon-site-book-24" fill="currentColor">
    <path d="M21.17 2.06A13.1 13.1 0 0 0 19 1.87a12.94 12.94 0 0 0-7 2.05 12.94 12.94 0 0 0-7-2 13.1 13.1 0 0 0-2.17.19 1 1 0 0 0-.83 1v12a1 1 0 0 0 1.17 1 10.9 10.9 0 0 1 8.25 1.91l.12.07h.11a.91.91 0 0 0 .7 0h.11l.12-.07A10.899 10.899 0 0 1 20.83 16 1 1 0 0 0 22 15V3a1 1 0 0 0-.83-.94ZM11 15.35a12.87 12.87 0 0 0-6-1.48H4v-10c.333-.02.667-.02 1 0a10.86 10.86 0 0 1 6 1.8v9.68Zm9-1.44h-1a12.87 12.87 0 0 0-6 1.48V5.67a10.86 10.86 0 0 1 6-1.8c.333-.02.667-.02 1 0v10.04Zm1.17 4.15a13.098 13.098 0 0 0-2.17-.19 12.94 12.94 0 0 0-7 2.05 12.94 12.94 0 0 0-7-2.05c-.727.003-1.453.066-2.17.19A1 1 0 0 0 2 19.21a1 1 0 0 0 1.17.79 10.9 10.9 0 0 1 8.25 1.91 1 1 0 0 0 1.16 0A10.9 10.9 0 0 1 20.83 20a1 1 0 0 0 1.17-.79 1 1 0 0 0-.83-1.15Z"/>
  </symbol>
  <!-- Eye with Check (24x24) -->
  <symbol
    id="icon-site-accessibility"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <!-- Eye -->
    <path d="M1 12s4-6 11-6 11 6 11 6-4 6-11 6S1 12 1 12z"/>
    <circle cx="12" cy="12" r="3"/>
    <!-- Checkmark -->
    <polyline points="9 12 11 14 15 9"/>
  </symbol>

  <symbol viewBox="0 0 12 12" id="icon-chevron-right-12">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.183 10.192a.625.625 0 0 1 0-.884L7.487 6 4.183 2.692a.625.625 0 0 1 .884-.884l3.745 3.75a.625.625 0 0 1 0 .884l-3.745 3.75a.625.625 0 0 1-.884 0Z"
    />
  </symbol>

  <symbol viewBox="0 0 16 16" id="icon-external-link-16">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.586 3 7.293 7.293a1 1 0 0 0 1.414 1.414L13 4.414V6a1 1 0 1 0 2 0V1.997A.997.997 0 0 0 14 1h-4a1 1 0 1 0 0 2h1.586ZM1 5.5A2.5 2.5 0 0 1 3.5 3H6a1 1 0 0 1 0 2H3.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V10a1 1 0 1 1 2 0v2.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 1 12.5v-7Z"
    />
  </symbol>
</svg>

<header class=[
  "primary-nav-wrapper",
  {
    glass: !navExpanded,
  },
]>
  <div class="page-grid-container">
    <nav
      id="primary-nav"
      class="nav primary-nav"
      role="navigation"
      aria-label="Main navigation"
    >
      <div class="nav__container">
        <div class="nav__content">
          <a href=urls.root>
            <div class="nav__brand">
              <div class="nav__logo">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="nav__logo-icon"
                  aria-hidden="true"
                >
                  <use href="#site-logo"/>
                </svg>
              </div>
              <span class="nav__brand-text">Evo Web</span>
            </div>
          </a>
          <ul class="nav__links">
            <li><a href=urls.components class="nav__link">Components</a></li>
            <li>
              <a href=urls.accessibility class="nav__link">Accessibility</a>
            </li>
            <li><a href=urls.guides class="nav__link">Guides</a></li>
            <li><a href=urls.newsletter class="nav__link">Newsletter</a></li>
            <li>
              <a
                href="https://github.com/eBay/evo-web"
                class="header__social-link nav__link"
                aria-label="Evo Web GitHub"
                target="_blank"
              >
                <svg
                  width="24"
                  height="24"
                  aria-hidden="true"
                  class="icon icon--24"
                >
                  <use href="#icon-github-24"/>
                </svg>
              </a>
            </li>
          </ul>
          <div class="nav__controls">
            <theme-switcher class="theme-switcher--nav"/>
            <search/>
          </div>
          <button
            id="mobile-nav-toggle"
            class="app-bar-menu mobile-nav-toggle icon-button"
            aria-label="Toggle mobile menu"
            aria-expanded=navExpanded ? "true" : "false"
            aria-controls="primaryNav"
            onClick() {
              navExpanded = !navExpanded;
            }
          >
            <svg
              class="icon icon-20 mobile-menu__open"
              height="18"
              width="18"
              aria-hidden="true"
            >
              <use href="#icon-menu-20"/>
            </svg>
          </button>
        </div>
      </div>
    </nav>

    <div
      id="site-nav-mobile-panel"
      aria-labelledby="dialog-title"
      aria-modal="true"
      class="site-nav-mobile-panel panel-dialog panel-dialog--mask-fade-slow panel-dialog--js keyboard-trap--active"
      hidden=!navExpanded
      role="dialog"
      onKeyUp({ key }) {
        if (key === "Escape") {
          navExpanded = false;
        }
      }
    >
      <div class="panel-dialog__window panel-dialog__window--end panel-dialog__window--slide">
        <div class="panel-dialog__header">
          <h2 id="dialog-title" class="large-text-1 bold-text">Site Menu</h2>
          <button
            aria-label="Close dialog"
            class="icon-button panel-dialog__close"
            type="button"
            onClick() {
              navExpanded = false;
            }
          >
            <svg
              class="icon icon-20 mobile-menu__close"
              height="18"
              width="18"
              aria-hidden="true"
            >
              <use href="#icon-close-20"/>
            </svg>
          </button>
        </div>
        <div class="mobile-theme-switcher">
          <theme-switcher/>
        </div>
        <div class="panel-dialog__main">
          <div id="site-nav-mobile" class="site-nav-mobile">
            <div class="tabs">
              <div class="tabs__items" role="tablist">
                <div
                  aria-controls="default-tabpanel-1"
                  aria-selected="true"
                  class="tabs__item"
                  id="default-tab-1"
                  role="tab"
                >
                  <svg
                    aria-hidden="true"
                    class="icon"
                    width="20"
                    height="20"
                    fill="currentColor"
                  >
                    <use href="#icon-site-rocket-24"/>
                  </svg>
                  <span>Main Navigation</span>
                </div>
                <div
                  aria-controls="default-tabpanel-2"
                  aria-selected="false"
                  class="tabs__item"
                  id="default-tab-2"
                  role="tab"
                >
                  <svg
                    aria-hidden="true"
                    class="icon"
                    width="20"
                    height="20"
                    fill="currentColor"
                  >
                    <use href="#icon-site-puzzle-24"/>
                  </svg>
                  <span>Components</span>
                </div>
                <div
                  aria-controls="default-tabpanel-3"
                  aria-selected="false"
                  class="tabs__item"
                  id="default-tab-3"
                  role="tab"
                >
                  <svg
                    aria-hidden="true"
                    class="icon"
                    width="20"
                    height="20"
                    fill="currentColor"
                  >
                    <use href="#icon-site-accessibility"/>
                  </svg>
                  <span>Accessibility</span>
                </div>
                <div
                  aria-controls="default-tabpanel-4"
                  aria-selected="false"
                  class="tabs__item"
                  id="default-tab-4"
                  role="tab"
                >
                  <svg
                    aria-hidden="true"
                    class="icon"
                    width="20"
                    height="20"
                    fill="currentColor"
                  >
                    <use href="#icon-site-book-24"/>
                  </svg>
                  <span>Guides</span>
                </div>
              </div>
              <div class="tabs__content">
                <div
                  aria-labelledby="default-tab-1"
                  class="tabs__panel"
                  id="default-tabpanel-1"
                  role="tabpanel"
                >
                  <div class="tabs__cell">
                    <nav
                      id="primary-nav-mobile"
                      class="primary-nav-mobile"
                      aria-label="Site navigation"
                    >
                      <ul class="app-bar__links subnav__links">
                        <li><a href=urls.components>Components</a></li>
                        <li><a href=urls.accessibility>Accessibility</a></li>
                        <li><a href=urls.guides>Guides</a></li>
                        <li><a href=urls.newsletter>Newsletter</a></li>
                        <li>
                          <a
                            href="https://github.com/eBay/evo-web/"
                            onBlur(event, target) {
                              const relatedTarget = (
                                event as unknown as FocusEvent
                              ).relatedTarget;
                              const navList = target.closest(".app-bar__links");
                              if (
                                !relatedTarget ||
                                !navList?.contains(relatedTarget as Node)
                              ) {
                                navExpanded = false;
                              }
                            }
                          >
                            Github Repo
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
                <div
                  aria-labelledby="default-tab-2"
                  class="tabs__panel"
                  hidden
                  id="default-tabpanel-2"
                  role="tabpanel"
                >
                  <div class="tabs__cell">
                    <nav class="components-nav" aria-label="CSS Components">
                      <ul class="modules-expander__list subnav__links">
                        <components-list/>
                      </ul>
                    </nav>
                  </div>
                </div>

                <div
                  aria-labelledby="default-tab-3"
                  class="tabs__panel"
                  hidden
                  id="default-tabpanel-3"
                  role="tabpanel"
                >
                  <div class="tabs__cell">
                    <nav
                      class="accessibility-nav"
                      aria-label="Accessibility Standards and Patterns"
                    >
                      <ul class="subnav__links">
                        <li>
                          <h3>
                            <a href=urls.accessibility>Accessibility Docs</a>
                          </h3>
                        </li>
                        <a11y-docs-list a11yDocs=a11yDocs/>
                      </ul>
                    </nav>
                  </div>
                </div>

                <div
                  aria-labelledby="default-tab-4  "
                  class="tabs__panel"
                  hidden
                  id="default-tabpanel-4"
                  role="tabpanel"
                >
                  <div class="tabs__cell">
                    <nav class="examples-nav" aria-label="Guides">
                      <ul class="modules-expander__list subnav__links">
                        <li>
                          <a href=`${urls.guides}/page-grid`>
                            Page Grid Use Guide
                          </a>
                        </li>
                        <li>
                          <a href=`${urls.guides}/skeleton`>
                            Skeleton Use Guide
                          </a>
                        </li>
                        <li>
                          <a href=`${urls.guides}/animation`>Animation Guide</a>
                        </li>
                        <li>
                          <a href=`${urls.guides}/theming`>Theming Guide</a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
